import { UpdateUserAttributesInput } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';
import { InputField } from '@/components/Auth/Buttons';
import FreeTrialBanner from '@/components/FreeTrial/FreeTrialBanner';

export default function ProfilePage() {
  const [formData, setFormData] = useState<UpdateUserAttributesInput | null>();
  const [clean, setClean] = useState(true);
  const [isUpdatingHostTips, setIsUpdatingHostTips] = useState(false);

  const navigate = useNavigate();
  const { userAttributes, updateUserAttributes, hostData, updateHostData } = useAuth();

  useEffect(() => {
    setFormData({
      userAttributes: {
        given_name: userAttributes?.given_name,
        family_name: userAttributes?.family_name
      }
    });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setClean(false);
    setFormData({
      userAttributes: {
        ...formData?.userAttributes,
        [name]: value
      }
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await updateUserAttributes(formData!);
      navigate('/dashboard');
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handleHostTipsToggle = async () => {
    if (isUpdatingHostTips) return;

    setIsUpdatingHostTips(true);

    await updateHostData({ hostTipsEnabled: !hostData?.hostTipsEnabled });

    setIsUpdatingHostTips(false);
  };

  return (
    <div className="w-900 mx-auto content-wrapper">
      <FreeTrialBanner />
      <h1 className="text-h1 text-secondary-navy-500 mb-40">Manage Account</h1>
      <div className="flex gap-84">
        <div>
          <h2 className="text-h2 mb-4">Profile</h2>
          <p className="text-neutral-400 text-body mb-40">Edit fields to update your profile</p>
          <form onSubmit={handleSubmit} className="space-y-20 w-408">
            <div>
              <InputField
                name="given_name"
                id="given_name"
                label="First Name"
                value={formData?.userAttributes.given_name}
                onChange={handleChange}
              />
            </div>
            <div>
              <InputField
                name="family_name"
                label="Last Name"
                id="family_name"
                value={formData?.userAttributes.family_name}
                onChange={handleChange}
              />
            </div>
            <div>
              <InputField
                name="email"
                id="email"
                label="Email"
                disabled
                value={userAttributes?.email}
                onChange={() => {}}
                description="At this time you cannot change your email address"
              />
            </div>
            <div>
              <button type="submit" className="btn btn-primary mt-4 w-full" disabled={clean}>
                Update Profile
              </button>
            </div>
          </form>
        </div>
        <div className="w-408">
          <h2 className="text-h2 mb-4">Host Tips</h2>
          <p className="text-neutral-400 text-body">
            Enable or disable In-Game tips for a game host
          </p>
          <p className="mt-24 mb-24 text-body-strong">
            The Host tips are currently {hostData?.hostTipsEnabled ? 'enabled' : 'disabled'}
          </p>
          <button
            type="button"
            className="btn btn-primary mt-4 w-full"
            onClick={handleHostTipsToggle}
            disabled={isUpdatingHostTips}
          >
            {hostData?.hostTipsEnabled ? 'Deactivate' : 'Activate'} Host Tips
          </button>
        </div>
      </div>
    </div>
  );
}
